import { TValidator } from './types';

export const REQUIRED_KEY = 'validation.required';
export const NOT_PRESENT_KEY = 'validation.notPresent';

export const required: TValidator = (value) => {
  if (value == null) {
    return REQUIRED_KEY;
  }

  if (Array.isArray(value) && !value.length) {
    return REQUIRED_KEY;
  }

  if (typeof value === 'object' && Object.keys(value).length === 0) {
    return REQUIRED_KEY;
  }

  if (typeof value === 'number' && Number.isNaN(value)) {
    return REQUIRED_KEY;
  }

  if (typeof value === 'string' && value === '') {
    return REQUIRED_KEY;
  }

  return undefined;
};

export const notPresent: TValidator = (value) => (required(value) === REQUIRED_KEY ? undefined : NOT_PRESENT_KEY);
